import React, { useState, useEffect, useRef, forwardRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Styles.css";
import Footer from "./Footer.js";
import Header from "./Header.js";
import { FaGooglePlay, FaApple } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

import gif1 from "../assets/landing1.gif";
import gif2 from "../assets/landing2.gif";
import gif3 from "../assets/landing3.gif";

import Image1 from "../assets/gif6.gif";
import Image2 from "../assets/memory companion.gif";

import gallery1 from "../assets/1.jpg";
import gallery2 from "../assets/2.png";
import gallery3 from "../assets/3.png";
import gallery4 from "../assets/4.png";
import gallery5 from "../assets/5.jpg";
import gallery6 from "../assets/6.png";
import gallery7 from "../assets/7.png";
import gallery8 from "../assets/8.jpg";
import gallery9 from "../assets/9.png";

import heroGif from "../assets/Image_20251006_163923_882.gif";

export default function GupsyPage() {
  const aboutRef = useRef(null);
  const getInTouchRef = useRef(null);

  /* ---------------- HERO SECTION ---------------- */

  const headingWords = [
    "Gupsy:",
    "India’s",
    "First",
    "AI",
    <span className="companion">Companion</span>,
    <span className="companion">App</span>,
  ];

  const [adopters, setAdopters] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    const fetchAdopters = async () => {
      try {
        const res = await fetch(
          "https://landing.guftagu.net/contact/adopters/",
        );
        const data = await res.json();
        setAdopters(data.count);
      } catch (error) {
        console.error("Error fetching adopters:", error);
      }
    };

    fetchAdopters();
  }, []);

  const handleButtonClick = async (url) => {
    window.open(url, "_blank", "noopener,noreferrer");

    try {
      const res = await fetch("https://landing.guftagu.net/contact/adopters/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: "guest",
          platform: "web",
        }),
      });

      const data = await res.json();
      setAdopters(data.count);
    } catch (error) {
      console.error("Error updating adopters:", error);
    }
  };

  /* ---------------- ANALYTICS ---------------- */

  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState("");
  // const [stats, setStats] = useState({
  //   totalUsers: 0,
  //   totalMessages: 0,
  //   totalCharacters: 0,
  // });

  // useEffect(() => {
  //   // init AOS (optional, for fade animations)
  //   AOS.init({ duration: 800, once: true });

  //   const fetchStats = async () => {
  //     try {
  //       setLoading(true);
  //       setError("");

  //       const res = await fetch(
  //         "https://landing.guftagu.net/contact/dashboard-stats/"
  //       );
  //       console.log("RES STATUS:", res.status);

  //       const text = await res.text();
  //       console.log("RAW RESPONSE:", text);

  //       if (!res.ok) {
  //         throw new Error("Failed to fetch stats");
  //       }

  //       const data = JSON.parse(text);
  //       console.log("PARSED DATA:", data);

  //       setStats({
  //         totalUsers: data.totalUsers || 0,
  //         totalMessages: data.totalMessages || 0,
  //         totalCharacters: data.totalCharacters || 0,
  //       });
  //     } catch (err) {
  //       console.error("FETCH ERROR:", err);
  //       setError("Unable to load latest stats right now.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchStats();
  // }, []);
  const stats = {
    totalUsers: "10K+",
    totalMessages: "1M+",
    totalCharacters: "3k+",
  };

  /* ---------------- GET IN TOUCH ---------------- */

  const [gifSrc, setGifSrc] = useState(gif1);
  const [activeButton, setActiveButton] = useState("AI");

  const handleGifChange = (type) => {
    setActiveButton(type);

    if (type === "AI") setGifSrc(gif1);
    if (type === "Training") setGifSrc(gif2);
    if (type === "Homework") setGifSrc(gif3);
  };

  const buttonDescriptions = {
    AI: "It’s the promise of constant support, guidance, and connection. Whether it’s helping you stay productive, lifting your mood, sparking creativity, or simply being there to listen, your companion is always by your side.",

    Training:
      "Always ready to push you closer to your goals, motivate you when it gets tough, and celebrate every little win along the way.",

    Homework:
      "Your friendly partner in learning, always ready to simplify tough concepts, guide you through assignments, and make studying less stressful.",
  };

  /* ---------------- TESTIMONIALS ---------------- */

  const testimonials = [
    {
      text: "gupsy helped me gain confidence in speaking english. i practice a little every day, and it’s fun.",
      name: "Aarav (India)",
    },
    {
      text: "gupsy motivates me to keep up my workout routine. It’s like having a partner who always cheers me on.",
      name: "Maria (Spain)",
    },
    {
      text: "gupsy is perfect for study breaks. short chats help me reset my mood.",
      name: "Jun (Japan)",
    },
    {
      text: "I chatted with gupsy during my workout — it made the session lighter and more fun!",
      name: "Amira (Egypt)",
    },
    {
      text: "Starting my day with a positive chat on gupsy makes the whole day brighter.",
      name: "Yuki (Japan)",
    },
    {
      text: "gupsy is like a friend who reminds me to drink water and stretch!",
      name: "Elena (Italy)",
    },
    {
      text: "gupsy helps me relax before work. a few minutes of chatting makes me smile.",
      name: "Chen (China)",
    },
    {
      text: "I use gupsy while journaling. it helps me reflect and think deeper about my day.",
      name: "Noah (USA)",
    },
    {
      text: "gupsy motivates me to write my journal every evening. it feels like a conversation with myself.",
      name: "Isabella (Germany)",
    },
    {
      text: "gupsy helps me learn new english words in a fun way.",
      name: "Fatima (Morocco)",
    },
    {
      text: "gupsy reminds me to breathe and take breaks. it’s calming and genuine.",
      name: "Nadia (France)",
    },
    {
      text: "I use gupsy to practice French. it’s patient and fun to talk to.",
      name: "Leo (Brazil)",
    },
    {
      text: "gupsy helped me practice my job interviews. my answers sound much more natural now.",
      name: "Diego (Mexico)",
    },
    {
      text: "gupsy helps me stay focused while studying at home. it’s like a patient study buddy.",
      name: "Rina (Indonesia)",
    },
    {
      text: "gupsy keeps me company when i cook or clean. it turns daily chores into good moments.",
      name: "Aisha (Kenya)",
    },
  ];

  const loopSlides = [...testimonials, ...testimonials];

  /* ---------------- FAQ ---------------- */

  const faqData = [
    {
      question: "What is gupsy?",
      answer:
        "gupsy is your AI companion — someone you can talk to, confide in, and grow with. it listens, understands, and connects emotionally, just like a real person.",
    },
    {
      question: "Is gupsy a mental health app or a therapy substitute?",
      answer:
        "gupsy is designed to offer comfort and emotional companionship, not clinical therapy. it helps you reflect, feel heard, and find calm — but it isn’t a replacement for professional care.",
    },
    {
      question: "When is gupsy launching?",
      answer:
        "gupsy is in its final testing phase and launching soon! sign up for early access to be among the first to meet your AI companion.",
    },
    {
      question: "Can I talk to gupsy through voice calls too?",
      answer:
        "yes. You can chat with gupsy through text or voice. talking feels natural — like calling someone who truly listens.",
    },
    {
      question: "How does mood tracking work on gupsy?",
      answer:
        "gupsy gently observes your words, tone, and interactions to sense your mood. over time, it learns your emotional patterns and helps you understand yourself better.",
    },
    {
      question: "Can I customize the personality of the AI?",
      answer:
        "absolutely. You can shape gupsy’s personality — choose traits, tone, and emotional depth. every companion becomes unique to you.",
    },
    {
      question: "Can I create my own AI companion?",
      answer:
        "yes! you can design your own character — name them, define their traits, and build a one-of-a-kind connection.",
    },
    {
      question: "Is my data safe with gupsy?",
      answer:
        "your privacy is our top priority. all your conversations are encrypted and stored securely. gupsy never shares or sells your data — ever.",
    },
    {
      question: "Is gupsy free to use?",
      answer:
        "gupsy is a paid experience designed to maintain quality and privacy. however, new users receive free coins on first signup, and you can earn bonus rewards during special events announced in the app. This way, everyone gets a chance to experience meaningful conversations with their AI companion.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  /* ---------------- GALLERY ---------------- */

  const galleryImages = [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
  ];

  return (
    <div className="landing-page">
      {/* HEADER */}
      <Header
        sectionsRef={{
          about: aboutRef,
          getInTouch: getInTouchRef,
        }}
      />

      {/* HERO SECTION */}

      <div className="container-fluid hero-container">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-6 px-4 text-white hero-text">
            <h1 className="hero-heading">
              {headingWords.map((word, idx) => (
                <span key={idx} style={{ "--i": idx }}>
                  {word}&nbsp;
                </span>
              ))}
            </h1>

            <p className="hero-subheading mt-3">
              Talk in your language. Call when you need to be heard.
              <br />
              gupsy listens, remembers, and responds like a friend—24/7.
              <br />
              {/* Pre-register today for exclusive early access. */}
            </p>

            <div className="d-flex gap-3 mt-4">
              <button
                className="icon-btn"
                onClick={() =>
                  handleButtonClick("https://apps.apple.com/app/your-app-id")
                }
              >
                <FaApple className="icon" />
                <span className="hover-text">App Store</span>
              </button>

              <button
                className="icon-btn"
                onClick={() =>
                  handleButtonClick(
                    "https://play.google.com/store/apps/details?id=com.gupsy.ai",
                  )
                }
              >
                <FaGooglePlay className="icon" />
                <span className="hover-text">Google Play</span>
              </button>
            </div>

            <p className="early-text mt-4">
              🚀 Join a growing community of <b className="companion">10K+</b>{" "}
              users worldwide
            </p>
          </div>

          <div className="col-lg-4 text-center gif-container">
            <img src={heroGif} alt="App Animation" className="hero-gif" />
          </div>
        </div>
      </div>

      {/* ANALYTICS */}

      <section className="analytics-section pb-5">
        <div className="container">
          <div className="row g-4 justify-content-center">
            {/* USERS */}
            <div className="col-lg-4 col-md-6">
              <div className="analytics-card">
                <div className="analytics-icon users">
                  <i className="bi bi-people-fill"></i>
                </div>

                <h2>{stats.totalUsers}</h2>

                <p>Total Users</p>
              </div>
            </div>

            {/* MESSAGES */}
            <div className="col-lg-4 col-md-6">
              <div className="analytics-card">
                <div className="analytics-icon messages">
                  <i className="bi bi-chat-dots-fill"></i>
                </div>

                <h2>{stats.totalMessages}</h2>

                <p>Total Messages</p>
              </div>
            </div>

            {/* CHARACTERS */}
            <div className="col-lg-4 col-md-6">
              <div className="analytics-card">
                <div className="analytics-icon characters">
                  <i className="bi bi-robot"></i>
                </div>

                <h2>{stats.totalCharacters}</h2>

                <p>Total Characters</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VISION */}

      {/* <section className="vision-section d-flex flex-column align-items-center my-5">
        <h2 className="vision-title text-center mb-5">
          Our <span className="highlight">vision</span>
        </h2>

        <div className="video-wrapper">
          <iframe
            className="vision-video"
            src="https://www.youtube.com/embed/ScMzIvxBSi4?autoplay=0&rel=0"
            title="Our Vision Video"
            frameBorder="0"
            allowFullScreen
          />
        </div>
      </section> */}

      {/* COMPANION */}

      <div className="features-wrapper">
        {/* <div className="register-btn-wrap">
          <button
            className="gradient-button shadow-lg"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Pre - Register
          </button>
        </div> */}

        <main className="features-main">
          <h1 className="features-heading">
            Your Companion <span className="gradient-text">Your Way</span>
          </h1>

          <p className="features-sub">
            gupsy adapts to you — learning your style, mood, and preferences
            until it feels like the perfect
            <span className="gradient-text">
              {" "}
              companion designed just for you
            </span>
          </p>

          <div className="roles-container">
            {[
              "The Listener",
              "The Motivator",
              "The Romantic",
              "The Playful Friend",
              "The Intellectual",
              "The Storyteller",
              "The Supportive Guide",
              "The Coach",
              "The Language Buddy",
              "The Dreamer",
              "The Caretaker",
              "Your 3AM Friend",
            ].map((role, i) => (
              <button key={i} className="role-button">
                {role}
              </button>
            ))}
          </div>
        </main>
      </div>

      {/* GET IN TOUCH */}

      <div className="container">
        <div className="d-flex flex-row flex-wrap justify-content-center align-items-start outer-container">
          <div className="buttons-column">
            <div className="futuristic-text">
              Your AI <span className="highlight">Future Awaits...</span>
            </div>

            {["AI", "Training", "Homework"].map((type) => (
              <div className="button-wrapper" key={type}>
                <button
                  className={`gradient-btn ${
                    activeButton === type ? "active" : ""
                  }`}
                  onClick={() => handleGifChange(type)}
                >
                  {type === "AI"
                    ? "Your AI Companion"
                    : type === "Training"
                      ? "Your Training Buddy"
                      : "Homework Companion"}
                </button>

                {activeButton === type && (
                  <p className="hover-description show">
                    {buttonDescriptions[type]}
                  </p>
                )}
              </div>
            ))}
          </div>

          <div className="phone-frame">
            <img src={gifSrc} alt="Animated content" className="phone-video" />
          </div>
        </div>
      </div>

      {/* HOW IT WORKS */}

      <section className="memory-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="memory-image" style={{ marginRight: "30%" }}>
                <img src={Image1} alt="24/7 Calling" className="img-fluid" />
              </div>
            </div>

            <div className="col-lg-7">
              <div className="memory-item" style={{ marginRight: "8%" }}>
                <h3 className="memory-title">
                  24*7 <span style={{ color: "#ff007f" }}>Calling</span>
                </h3>

                <p>
                  gupsy breaks barriers by talking to you in the language you're
                  most comfortable with.
                </p>
              </div>
            </div>
          </div>

          <div className="row align-items-center flex-lg-row-reverse">
            <div className="col-lg-5">
              <div className="memory-image" style={{ marginLeft: "30%" }}>
                <img
                  src={Image2}
                  alt="Remembers Memory"
                  className="img-fluid"
                />
              </div>
            </div>

            <div className="col-lg-7">
              <div className="memory-item" style={{ marginLeft: "12%" }}>
                <h3 className="memory-title">
                  Remembers Memory —
                  <span style={{ color: "#ff6f61" }}> not forgotten</span>
                </h3>

                <p>gupsy lets you design a companion that feels truly yours.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}

      <section className="neo-section">
        <h2 className="neo-title">
          Testi<span className="highlight">monials</span>
        </h2>

        <div className="neo-carousel">
          <div className="neo-track">
            {loopSlides.map((t, i) => (
              <div className="neo-card" key={i}>
                <p className="neo-text">“{t.text}”</p>

                <span className="neo-name">— {t.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}

      <div className="faq-wrapper">
        <h2 className="faq-title">
          We’ve got the <span className="highlight">answers</span>
        </h2>

        <div className="faq-grid">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className={`faq-item ${openIndex === idx ? "active" : ""}`}
            >
              <button className="faq-question" onClick={() => toggleFaq(idx)}>
                {item.question}

                <span className={`plus ${openIndex === idx ? "open" : ""}`}>
                  +
                </span>
              </button>

              <div className={`faq-answer ${openIndex === idx ? "show" : ""}`}>
                <div className="faq-answer-inner">{item.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* GALLERY */}

      <section className="gallery-section">
        <h2 className="gallery-title">
          Our <span className="highlight">Gallery</span>
        </h2>

        <div className="gallery-carousel">
          <div className="gallery-track">
            {galleryImages.map((img, i) => (
              <div className="gallery-card" key={i}>
                <img src={img} alt={`Gallery ${i + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* FOOTER */}
      <Footer
        sectionsRef={{
          about: aboutRef,
          getInTouch: getInTouchRef,
        }}
      />
    </div>
  );
}
